module.exports = __webpack_public_path__ + "img/spoon.e985f32d.png";